let DataBase2 = {
    top: {
        Name: "Shubham Bawner",
        img: "profile.jpg",
    },
    chat: {
        "EDUCATION": {
            name: "EDUCATION", 
            msgUnvisited: 1,
            img: "profile.jpg",
            sub: "B.Tech in Information Technology",
            chats: [
                {
                    sender: 0,
                    txt: "B.Tech in Information Technology\\National Institute Of Technology, Raipur\\2020 - 2024\\CGPA: 8.20/10",
                    img: "nitrr.JPG",
                    time: "2024",
                    link: "https://drive.google.com/file/d/1YnwbtdALxz6zdMPOiktizwOjN-9RC4o3/view?usp=drive_link"

                }
            ]
        },
        "SKILLS": {
            name: "SKILLS",
            msgUnvisited: 0,
            img: "profile.jpg",
            sub: "Technical Skills",
            chats: [
                {
                    sender: 0,
                    txt: "Backend & APIs: Java, Spring Boot, FastAPI, Node.js, Express.js, REST APIs, Microservices Architecture",
                    img: null,
                    time: "",
                    link: null
                },
                {
                    sender: 0,
                    txt: "Data & Storage: Oracle SQL, PostgreSQL, MongoDB, Redis, MyBatis, Schema Design, Query Optimization",
                    img: null,
                    time: "",
                    link: null
                },
                {
                    sender: 0,
                    txt: "Infra & DevOps: Linux, Docker, Jenkins, CI/CD Pipelines, JFrog Artifactory, Git, Bitbucket Pipelines, Nginx",
                    img: null,
                    time: "",
                    link: null
                },
                {
                    sender: 0,
                    txt: "AI / RAG / Search: Elasticsearch, Vector Search, Retrieval-Augmented Generation, Prompt Engineering",
                    img: null,
                    time: "",
                    link: null
                },
                {
                    sender: 0,
                    txt: "Frontend: React, StencilJS, SAP UI5 Fiori, Material-UI, HTML/CSS",
                    img: null,
                    time: "",
                    link: null
                },
                {
                    sender: 0,
                    txt: "Cloud (partial exposure): AWS (EC2, Lambda, S3), Cloud Architecture (Foundational)",
                    img: null,
                    time: "",
                    link: null
                }
            ]
        },
        "PROJECTS": {
            name: "PROJECTS",
            msgUnvisited: 13,
            img: "profile.jpg",
            sub: "Featured Projects",
            chats: [
                {
                    sender: 0,
                    txt: "E2E thread classification system\\Designed and developed an end-to-end thread classification system using Python (FastAPI) and LLMs (Llama 3.3) to automatically route 400+ daily customer support threads to the correct experts, saving over 20+ hours of manual work daily for forum moderators.",
                    img: null,
                    time: "2025",
                    link: "https://e2e.ti.com/"
                },
                {
                    sender: 0,
                    txt: "Customer support platform\\Played a major role in building a unified customer support platform using Spring Boot, Stencil.js, and Oracle SQL. This platform centralized three separate ticketing systems, providing a single point of contact for customer queries and integrating with backend services for ticket creation and management.",
                    img: null,
                    time: "2024",
                    link: "https://www.ti.com/customer-support/request-form"
                },
                {
                    sender: 0,
                    txt: "CAAD (Centralised Alert autoheal dashboard)\\Developed key components of a centralized dashboard for monitoring and auto-healing alerts from multiple systems like Icinga, New Relic, and Splunk. I built the FastAPI backend for alert injection and configuration, and the AngularJS frontend for displaying alerts and managing settings.",
                    img: null,
                    time: "2025",
                    link: null
                },
                {
                    sender: 0,
                    txt: "IIITPrep smart email llm integration\\Created a freelance automation tool using Google Apps Script and OpenAI APIs to streamline customer support for an EdTech startup. The system automatically drafts email responses by fetching customer data from various platforms like Razorpay and WooCommerce, saving 70% of the support team's time.",
                    img: null,
                    time: "2023",
                    link: "http://iiitprep.com"
                },
                {
                    sender: 0,
                    txt: "Unified Jenkins DB pipeline\\Designed and implemented a centralized Jenkins pipeline for automated SQL DDL/DML deployments for Oracle databases. This solution enforced version control, improved audit traceability, and reduced human error by standardizing the database deployment process across multiple teams.",
                    img: null,
                    time: "2025",
                    link: null
                },
                {
                    sender: 0,
                    txt: "AI kalpa DICOM viewer Desktop application\\Developed a secure, offline-first desktop DICOM viewer for medical imaging using Electron, React, and Node.js. The application supports viewing various image formats, persistent annotations, and real-time p2p messaging for doctors.",
                    img: null,
                    time: "2023",
                    link: null
                },
                {
                    sender: 0,
                    txt: "Deepthought Razorpay integration and gamification\\Integrated Razorpay payment gateway into a Node.js-based forum software (NodeBB). Implemented APIs for handling transactions, converting real money to virtual currency, and enabling course purchases, all recorded in a MongoDB database.",
                    img: null,
                    time: "2022",
                    link: "http://www.deepthought.education"
                },
                 {
                    sender: 0,
                    txt: "Stocks Portfolio tracking & Analytics System\\Google App Script as DB + vanilla js UI dashboard + Node.js Telegram bot for automated orders/portfolio data syncing from multiple brokers like Zerodha.",
                    img: null,
                    time: "",
                    link: "https://docs.google.com/document/d/17R-Geb2UeJBtq2TNFwHSv1LzVoK4JnxB5IUcbnEh1ec/edit?usp=sharing"
                },
                {
                    sender: 0,
                    txt: "CHESS GAME | REACT\\React based 2 player turn based chess game, with local storage synchronisation. Constructed algorithms for functionality of all basic operations like piece movement, piece capture, as well as complex operations like Castling, en-pass-en from scratch. Game history, undo/redo actions, as well as going back to any previous move.",
                    img: "chessup.jpeg",
                    time: "",
                    link: "https://chess-up.netlify.app/"
                },
                {
                    sender: 0,
                    txt: "E‑COMMERCE WEBSITE | REACT\\Developed React based frontend for E-commerce website for E-Cell, using MaterialUI framework templates. Integrated 5+ APIs in frontend for Functionality: User authentication, purchase product.",
                    img: null,
                    time: "",
                    link: "https://react-e-commerce-app12341253153461.netlify.app/"
                },
                {
                    sender: 0,
                    txt: "Smart Notes Desktop App\\Key-frame extraction + transcript → structured lecture summaries from video lectures (any source).",
                    img: null,
                    time: "",
                    link: "https://github.com/Shubhambawner/skripter"
                }
            ]
        },
        "EXPERIENCE": {
            name: "EXPERIENCE",
            msgUnvisited: 3,
            img: "profile.jpg",
            sub: "Work and Internships",
            chats: [
                {
                    sender: 0,
                    txt: "Software Developer Intern\\Texas Instruments\\Jan 2024 – Jun 2024 · May 2023 – Jul 2023",
                    img: null,
                    time: "2024",
                    link: "https://drive.google.com/file/d/1F8g84zSiipufadSgH_Gu9PcctyQyGeZO/view?usp=sharing"
                },
                {
                    sender: 0,
                    txt: "Backend Developer Intern\\Deep Thought Ed-Tech\\Feb 2022 – Jun 2022",
                    img: null,
                    time: "2022",
                    link: "https://internshala.com/student/certificate/93542659/7350DAB3-36A6-E142-0721-8C8CF1AA651A"
                },
                {
                    sender: 0,
                    txt: "Software Developer Intern\\AI Kalpa Pvt. Ltd\\Jan 2023 – Apr 2023",
                    img: null,
                    time: "2023",
                    link: "https://drive.google.com/file/d/1z8N2a10zQNQYup3ZpkP_uokFlDjsoN0b/view?usp=sharing"
                }
            ]
        },
        "ACHIEVEMENTS": {
            name: "ACHIEVEMENTS",
            msgUnvisited: 4,
            img: "profile.jpg",
            sub: "Recognitions and Accomplishments",
            chats: [
                {
                    sender: 0,
                    txt: "Rising Star Award (Q1 2025), Texas Instruments — recognized for impactful ownership and delivery.",
                    img: null,
                    time: "2025",
                    link: null
                },
                {
                    sender: 0,
                    txt: "2nd Runner Up, Codeutsava 6.0 () Hackathon.",
                    img: null,
                    time: "",
                    link: null
                },
                {
                    sender: 0,
                    txt: "500+ DSA problems solved over Leetcode, Geeksforgeeks, codechef, codeforces.",
                    img: null,
                    time: "",
                    link: "https://leetcode.com/u/noob_man_101/"
                },
                {
                    sender: 0,
                    txt: "Jee mains(2020) top 2 %time nationwide, Jee advanced(2020) top 11k nationwide.",
                    img: null,
                    time: "2020",
                    link: null
                }
            ]
        },
        "OTHER PROFILES": {
            name: "OTHER PROFILES",
            msgUnvisited: 6,
            img: "profile.jpg",
            sub: "Find me on other platforms",
            chats: [
                {
                    sender: 0,
                    txt: "Github",
                    img: null,
                    time: "",
                    link: "https://github.com/shubhambawner"
                },
                {
                    sender: 0,
                    txt: "LinkedIn",
                    img: null,
                    time: "",
                    link: "https://www.linkedin.com/in/shubham-bawner-456131205/"
                },
                {
                    sender: 0,
                    txt: "Leetcode",
                    img: null,
                    time: "",
                    link: "https://leetcode.com/u/noob_man_101/"
                },
                {
                    sender: 0,
                    txt: "Codechef",
                    img: null,
                    time: "",
                    link: "https://www.codechef.com/users/shubham_bawner"
                },
                {
                    sender: 0,
                    txt: "Codeforces",
                    img: null,
                    time: "",
                    link: "https://codeforces.com/profile/wurtzreaxnwittigreaxn"
                },
                {
                    sender: 0,
                    txt: "GeeksforGeeks",
                    img: null,
                    time: "",
                    link: "https://auth.geeksforgeeks.org/user/wurtzreaxnwittigreaxn"
                }
            ]
        },
        "CONTACT": {
            name: "CONTACT",
            msgUnvisited: 2,
            img: "profile.jpg",
            sub: "Get in touch",
            chats: [
                {
                    sender: 0,
                    txt: "Email: shubhambawner.official@gmail.com",
                    img: null,
                    time: "",
                    link: "mailto:shubhambawner.official@gmail.com"
                },
                {
                    sender: 0,
                    txt: "Phone: +91-7410730191",
                    img: null,
                    time: "",
                    link: "tel:+917410730191"
                }
            ]
        },
    }
}
export default DataBase2;